import affiliate from './en/affiliate'
import bankTransfer from './en/bankTransfer'
import cart from './en/cart'
import cartAndWarehouse from './en/cartAndWarehouse'
import common from './en/common'
import consult from './en/consult'
import debt from './en/debt'
import distribution from './en/distribution'
import estimation from './en/estimation'
import form from './en/form'
import home from './en/home'
import kol from './en/kol'
import order from './en/order'
import orderDetail from './en/orderDetail'
import packages from './en/package'
import pay from './en/pay'
import pecenter from './en/pecenter'
import points from './en/points'
import previewPackage from './en/previewPackage.json'
import previewPackageOptimize from './en/previewPackageOptimize'
import product from './en/product'
import returnChange from './en/returnChange'
import search from './en/search'
import shareCoupon from './en/shareCoupon'
import sharePackage from './en/sharePackage'
import shoppingGuide from './en/shoppingGuide'
import site from './en/site'
import status from './en/status'
import storage from './en/storage'
import tag from './en/tag'
import tips from './en/tips'
import transport from './en/transport'
import uniOrder from './en/uniOrder'
import warnTips from './en/warnTips'
export default {
  form,
  home,
  search,
  cart,
  product,
  order,
  pecenter,
  pay,
  common,
  estimation,
  packages,
  orderDetail,
  warnTips,
  status,
  tips,
  storage,
  uniOrder,
  bankTransfer,
  distribution,
  site,
  consult,
  transport,
  previewPackage,
  sharePackage,
  debt,
  previewPackageOptimize,
  points,
  shareCoupon,
  shoppingGuide,
  tag,
  cartAndWarehouse,
  affiliate,
  returnChange,
  kol,
}
